export * from './cache';
export * from './types';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache/lib/index.js
// module id = 378
// module chunks = 0